var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3406 17.8543L17.1062 14.0043C16.9061 13.8223 16.6431 13.7253 16.3727 13.7337C16.1024 13.742 15.8458 13.8551 15.6573 14.049L13.1646 16.6126C12.5646 16.498 11.3583 16.122 10.1167 14.8834C8.875 13.6407 8.49895 12.4313 8.3875 11.8355L10.949 9.34175C11.1431 9.15334 11.2564 8.89678 11.2647 8.62634C11.2731 8.35591 11.1759 8.09284 10.9937 7.89279L7.14479 3.65946C6.96254 3.45879 6.70924 3.33707 6.4387 3.32015C6.16815 3.30323 5.90166 3.39244 5.69583 3.56884L3.43541 5.50738C3.25532 5.68812 3.14783 5.92868 3.13333 6.18342C3.1177 6.44384 2.81979 12.6126 7.60312 17.398C11.776 21.5699 17.0031 21.8751 18.4427 21.8751C18.6531 21.8751 18.7823 21.8688 18.8167 21.8668C19.0714 21.8525 19.3118 21.7445 19.4917 21.5636L21.4292 19.3022C21.6063 19.097 21.6961 18.8307 21.6796 18.5602C21.663 18.2897 21.5414 18.0363 21.3406 17.8543Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f1d3dc67f641be22a54639c786bbe008.svg";
export { ForwardRef as ReactComponent };